import {
  ReplicantAsyncActionAPI,
  ReplicantEventHandlerAPI,
} from '@play-co/replicant';
import { ReplicantServer } from '../config';
import { MutableState } from '../schema';
import { migrateFriendIdsToSubstate } from '../features/friends/friends.modifiers';

export async function migrateFriendIdsToFriendsSubstate(
  state: MutableState,
  api:
    | ReplicantAsyncActionAPI<ReplicantServer>
    | ReplicantEventHandlerAPI<ReplicantServer>,
) {
  migrateFriendIdsToSubstate(state, api, false);
}
